import React, { useEffect, useState } from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, card }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      setCurrentImageIndex(0); // Reset carousel when modal opens
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      onClose();
    }
  };

  const nextImage = () => {
    if (card?.images && card.images.length > 1) {
      setCurrentImageIndex((prev) => (prev + 1) % card.images.length);
    }
  };

  const prevImage = () => {
    if (card?.images && card.images.length > 1) {
      setCurrentImageIndex((prev) => (prev - 1 + card.images.length) % card.images.length);
    }
  };

  const hasMultipleImages = card?.images && card.images.length > 1;
  const currentImage = card?.images ? card.images[currentImageIndex] : card?.image;

  return (
    <div 
      className={`modal-overlay ${isOpen ? 'modal-open' : 'modal-closing'}`}
      onClick={handleOverlayClick}
    >
      <div className={`modal-content ${card?.type === 'easter' ? 'easter-modal' : ''}`}>
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>
        
        <div className="modal-header">
          <h2 className="modal-title">{card?.title}</h2>
          {card?.type === 'easter' && <div className="modal-sparkles">✨🌟✨</div>}
        </div>
        
        {currentImage && (
          <div className="modal-image-container">
            {hasMultipleImages && (
              <button className="carousel-btn carousel-btn-prev" onClick={prevImage}>
                &#8249;
              </button>
            )}
            <img 
              src={currentImage} 
              alt={card?.title}
              className="modal-image"
              onLoad={() => console.log('Imagen cargada:', currentImage)}
              onError={(e) => {
                console.log('Error cargando imagen:', currentImage);
                e.target.style.display = 'none';
              }}
            />
            {hasMultipleImages && (
              <button className="carousel-btn carousel-btn-next" onClick={nextImage}>
                &#8250;
              </button>
            )}
            {hasMultipleImages && (
              <div className="carousel-indicators">
                {card.images.map((_, index) => (
                  <span
                    key={index}
                    className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                    onClick={() => setCurrentImageIndex(index)}
                  />
                ))}
              </div>
            )}
          </div>
        )}
        
        <div className="modal-description">
          <p>{card?.description}</p>
        </div>
        
        {card?.type === 'easter' && (
          <div className="easter-badge">
            🏆 ¡EASTER EGG ENCONTRADO! 🏆
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
